<template>
    <div class="jobs">
        <div class="grid grid-cols-1 lg:grid-cols-6 gap-4">
            <div class="lg:col-span-5">
                <h5 class="text-2xl font-semibold">{{ title }}</h5>
                <p class="font-medium mt-2">{{ `Location: ${company} - ${location}` }}</p>
                <p class="mt-4">{{ description }}</p>
            </div>
            <div class="lg:col-span-1 flex lg:justify-end">
                <nuxt-link :to="navTo">
                    <button class="btn btn-secondary btn-bordered">View Details</button>
                </nuxt-link>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    },
    location: {
        type: String,
        default: ''
    },
    company: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    navTo: {
        type: String,
        default: ''
    }
});
</script>

<style lang="scss" scoped>
.jobs {}
</style>